import PropTypes from 'prop-types';

import styles from './Datepicker.module.scss';
import FormRow from './FormRow';

function Datepicker({
  rowModifier,
  onChange,
  required,
  label,
  value,
  name,
  id,
  min,
  max,
}) {
  return (
    <FormRow id={id} label={label} required={required} modifier={rowModifier}>
      <input
        className={styles.datepicker}
        onChange={onChange}
        required={required}
        value={value}
        name={name}
        type="date"
        min={min}
        max={max}
        id={id}
      />
    </FormRow>
  );
}

Datepicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  rowModifier: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
};

export default Datepicker;
